import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/jpg_png/home1.jpg";
import ProjectImg2 from "../../assets/jpg_png/home11.jpg";
import ProjectImg3 from "../../assets/jpg_png/home12.jpg";
import ProjectImg4 from "../../assets/jpg_png/home13.jpg";
import ProjectImg5 from "../../assets/jpg_png/home14.jpg";
import ProjectImg6 from "../../assets/jpg_png/home15.jpg";
import ProjectImg7 from "../../assets/jpg_png/comercial1.jpg";
import ProjectImg8 from "../../assets/jpg_png/comercial4.jpg";
import ProjectImg9 from "../../assets/jpg_png/commercial9.jpg";
import AddImage2 from "../../assets/jpg_png/home16.jpg";

export default function Projects() {
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold" style={{ color: "#9E9D24" }}>
              Our Awesome Projects
            </h1>
            <p className="font15" style={{ color: "#111", fontWeight: "600" }}>
              "All our projects are unique and designed to last, Take a look at
              our recent works to find it out for yourself".
              {/* <br />
              labore et dolore magna aliquyam erat, sed diam voluptua. */}
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg1}
                title="P.S.Palliy Villa "
                text="Produture."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg2}
                title="Jaquar Bath Solutions"
                text="Produture."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg3}
                title="VR1 Software Comapany"
                text="Hyderabad-Miyapur."
                action={() => alert("clicked")}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg4}
                title="Mallapeta 42Villa"
                text="Hyderabad-Bachupalliy Villa."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg5}
                title="Jubilee hills 32Villa"
                text="Hyderabad."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg6}
                title="Parryware Showroom"
                text="Tirupathi."
                action={() => alert("clicked")}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg7}
                title="AK Traders"
                text="Produture."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg8}
                title="Sudakar-Agencies:Jaquar"
                text="Produture."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg9}
                title="Roca Showroom"
                text="Tirupathi."
                action={() => alert("clicked")}
              />
            </div>
          </div>
          {/* <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              <Link to="blog">
                <FullButton title="Load More" action={() => alert("clicked")} />
                <FullButton title="Load More" />
              </Link>
            </div>
          </div> */}
        </div>
      </div>
      <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={AddImage2} alt="add" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold" style={{ color: "#7620ff" }}>
                --few words about our founder
              </h4>
              <h3 className="font25 extraBold" style={{ color: "#9E9D24" }}>
                “If you get tired, learn to rest, not to quit"
              </h3>
              <p
                className="font12"
                style={{
                  color: "#111",
                  fontSize: "14px",
                  fontWeight: "600",
                  textAlign: "justify",
                }}
              >
                This is Kata Niranjan, I've always been artistic and creatively
                minded. During my childhood years, I made up stories to draw
                illustrations or cartoons alongside these stories, I studied at
                Hamstech 3Years,I am Btech civil background,completing both
                architectural drawing and interior design.
                <br />
                Nlite is an interior design company commited to producing high
                quality,ergonomically throught-through residential, commercial.
                we create design in a collaborative environment enabling us to
                deliver the client's ultimate vision. Our designs are current,
                yet still possess a timeless style generating broad market
                appeal. Our reputation for outstanding service and our
                innovative design style creates an extremely successful
                partnership with our clients.
              </p>
              <ButtonsRow
                className="flexNullCenter"
                style={{ margin: "30px 0" }}
              >
                <div style={{ width: "190px" }}>
                  <FullButton
                    title="Get Started"
                    action={() => alert("clicked")}
                  />
                </div>
                <div style={{ width: "190px", marginLeft: "15px" }}>
                  <Link to="contact">
                    <FullButton
                      title="Contact Us"
                      // action={() => alert("clicked")}
                      border
                    />
                  </Link>
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0px 100px 0;
  margin: 40px 0px 80px 0px;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: 607px;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
